import { AxiosRequestConfig, AxiosResponse } from 'axios'
import {
  FilterItem,
  ImageModel,
  Manufacturer,
  Store,
  AvailabilitesProduct,
} from './types'
import { apiService } from '../../api-base'

export class GlobalService {
  static getStores(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Store[]>> {
    return apiService.get<AxiosResponse<Store[]>>(`/stores`, config)
  }

  static getFilters(
    name: 'products' | 'categories' | 'payments' | 'shipping' | 'countries',
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FilterItem[]>> {
    return apiService.get<AxiosResponse<FilterItem[]>>(
      `/filters/${name}`,
      config,
    )
  }

  static uploadImage(data: FormData): Promise<ImageModel> {
    return apiService.post<ImageModel>('/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  static getManufacturers(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Manufacturer[]>> {
    return apiService.get<AxiosResponse<Manufacturer[]>>(
      '/manufacturers',
      config,
    )
  }

  static getAvailableProducts(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<AvailabilitesProduct[]>> {
    return apiService.get<AxiosResponse<AvailabilitesProduct[]>>(
      `/products/availabilities`,
      config,
    )
  }
}
